import type { IconSvgObject } from './types';

const PenTool01Icon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14.5 13L12.4552 8.30584C12.2775 7.89805 11.7225 7.89805 11.5448 8.30584L9.5 13", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M6.5 20.5L8.30204 13.7423C8.41878 13.3046 8.81523 13 9.26828 13H14.7317C15.1848 13 15.5812 13.3046 15.698 13.7423L17.5 20.5", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default PenTool01Icon;
